import { createContext, useContext, useState, useEffect } from 'react';

const LANGUAGES = {
  lt: {
    code: 'lt',
    name: 'Lietuvių',
    flag: '🇱🇹',
    tmdbCode: 'lt'
  },
  en: {
    code: 'en',
    name: 'English',
    flag: '🇬🇧',
    tmdbCode: 'en-US'
  },
  uk: {
    code: 'uk',
    name: 'Українська',
    flag: '🇺🇦',
    tmdbCode: 'uk'
  }
};

// UI translations
const TRANSLATIONS = {
  lt: {
    // Header
    searchPlaceholder: 'Ieškoti filmų...',
    login: 'Prisijungti',
    register: 'Registruotis',
    logout: 'Atsijungti',
    movies: 'Filmai',
    tvShows: 'TV Serialai',
    cinema: 'Kino seansai',
    watchlist: 'Žiūrėjimo sąrašas',
    watched: 'Peržiūrėti',
    collections: 'Kolekcijos',
    favorites: 'Mėgstamiausi',
    
    // Mobile navigation short labels
    moviesShort: 'Filmai',
    tvShort: 'TV',
    cinemaShort: 'Kinas',
    watchlistShort: 'Sąrašas',
    watchedShort: 'Matyti',
    collectionsShort: 'Rinkiniai',
    favoritesShort: 'Mėgstami',
    
    // Search
    showAllResults: 'Rodyti visus rezultatus',
    searchDropdownLoading: 'Ieškoma...',
    searchSuggestionsEmpty: 'Rezultatų nerasta',
    searchSuggestionsEmptyHint: 'Pagal šią paiešką nieko nerasta. Pabandykite kitus žodžius.',
    film: 'Film',
    
    // Auth
    confirmEmail: 'Patvirtinkite savo el. pašto adresą',
    confirmEmailDesc: 'Patikrinkite savo el. paštą ir spauskite patvirtinimo nuorodą, kad galėtumėte naudotis visomis funkcijomis.',
    resendEmail: 'Siųsti dar kartą',
    sending: 'Siunčiama...',
    dismiss: 'Atmesti',
    
    // Auth benefits page
    createFreeAccount: 'Sukurkite nemokamą paskyrą',
    loginOrRegisterPrompt: 'Prisijunkite arba užsiregistruokite, kad galėtumėte naudotis visomis funkcijomis',
    watchlistBenefit: 'Žiūrėjimo sąrašas',
    watchlistBenefitDesc: 'Saugokite filmus ir serialus, kuriuos norite pažiūrėti vėliau',
    watchedBenefit: 'Peržiūrėti filmai',
    watchedBenefitDesc: 'Sekite, ką jau matėte ir įvertinkite',
    favoritesBenefit: 'Mėgstamiausi',
    favoritesBenefitDesc: 'Kurkite savo mėgstamiausių filmų kolekciją',
    registerFree: 'Registruotis nemokamai',
    alreadyHaveAccount: 'Jau turiu paskyrą',
    registrationFast: 'Registracija trunka mažiau nei minutę',
    
    // Media details
    description: 'Aprašymas',
    noDescription: 'Aprašymas nepateiktas',
    shareReviewHint: 'Pridėkite savo apžvalgą, kad ji būtų rodoma sugeneruotame vaizde. Jei apžvalgos nepridėsite, bus rodomas filmo aprašymas. Jūsų įvertinimas bus įtrauktas, jei esate pažymėję filmą kaip peržiūrėtą.',
    goBack: 'Grįžti atgal',
    season: 'sezonas',
    seasons: 'sezonai',
    episode: 'epizodas',
    episodes: 'epizodai',
    streamingOn: 'Transliuoja',
    studio: 'Studija',
    country: 'Šalis',
    mediaLanguage: 'Kalba',
    addToFavorites: 'Pridėti į mėgstamiausius',
    removeFromFavorites: 'Pašalinti iš mėgstamiausių',
    watchLater: 'Žiūrėti vėliau',
    removeFromWatchlist: 'Pašalinti iš sąrašo',
    markAsWatched: 'Pažymėti kaip peržiūrėtą',
    removeFromWatched: 'Pašalinti iš peržiūrėtų',
    share: 'Dalintis',
    whereToWatch: 'Kur žiūrėti Lietuvoje',
    subscription: 'Prenumerata',
    rent: 'Nuoma',
    buy: 'Pirkti',
    free: 'Nemokamai',
    trailers: 'Anonsai',
    cast: 'Aktoriai',
    similarMovies: 'Panašūs filmai',
    similarShows: 'Panašūs TV serialai',
    streamingInfo: 'Informacija apie streaming paslaugas pateikta',
    pricesVary: 'Kainos ir prieinamumas gali skirtis',
    budget: 'Biudžetas',
    revenue: 'Pajamos',
    notAvailable: 'Neprieinamas Lietuvoje',
    notAvailableDesc: 'Šis filmas šiuo metu neprieinamas žiūrėjimui Lietuvoje per oficialias platformas',
    movieNotFound: 'Filmas nerastas',
    tvNotFound: 'TV serialas nerastas',
    movieNotFoundDesc: 'Atsiprašome, šio filmo informacija šiuo metu neprieinama. Gali būti, kad filmas buvo pašalintas iš duomenų bazės arba įvyko techninis nesklandumas.',
    tvNotFoundDesc: 'Atsiprašome, šio TV serialo informacija šiuo metu neprieinama. Gali būti, kad serialas buvo pašalintas iš duomenų bazės arba įvyko techninis nesklandumas.',
    unknownError: 'Įvyko nežinoma klaida',
    
    // Collections
    backToCollections: 'Grįžti į kolekcijas',
    collectionEmpty: 'Kolekcija tuščia',
    collectionEmptyDesc: 'Šioje kolekcijoje kol kas nėra elementų.',
    showing: 'Rodoma',
    of: 'iš',
    curator: 'Kuratorius',
    items: 'elementų',
    loadMore: 'Krauti daugiau',
    loading: 'Kraunama...',
    errorLoading: 'Klaida kraunant duomenis',
    retry: 'Bandyti dar kartą',
    curatorCollections: 'Kuratorių kolekcijos',
    collectionsDesc: 'Atraskite rankomis atrinktus filmų ir TV serialų sąrašus iš patikimiausių kuratorių',
    collectionsCount: 'Kolekcijų',
    movieCollections: 'Filmų kolekcijų',
    tvCollections: 'TV serialų kolekcijų',
    searchCollections: 'Ieškoti kolekcijų...',
    
    // Footer
    footerDesc: 'Jūsų galutinė filmų ir TV serialų atradimo vieta. Gaukite personalizuotus pasiūlymus ir niekada nepraleiskite to, kas populiaru.',
    discover: 'Atraskite',
    popularMovies: 'Populiarūs filmai',
    topRated: 'Geriausiai įvertinti',
    comingSoon: 'Greit pasirodys',
    help: 'Pagalba',
    helpCenter: 'Pagalbos centras',
    contactUs: 'Susisiekite su mumis',
    contactNav: 'Kontaktai',
    contactTitle: 'Kontaktai',
    contactIntro: 'Turite klausimų ar pasiūlymų? Parašykite mums — atsakysime kaip galėsime greičiau.',
    contactNameLabel: 'Vardas',
    contactEmailLabel: 'El. paštas',
    contactMessageLabel: 'Žinutė',
    contactSubmit: 'Siųsti',
    contactSending: 'Siunčiama...',
    contactSuccess: 'Žinutė išsiųsta. Ačiū!',
    contactError: 'Nepavyko išsiųsti. Bandykite dar kartą arba rašykite el. paštu žemiau.',
    contactNotConfigured: 'Žinučių siuntimas dar nesukonfigūruotas. Naudokite el. paštą žemiau.',
    contactFallback: 'Galite rašyti ir tiesiai:',
    contactEmailInvalid: 'Įveskite galiojantį el. pašto adresą',
    contactNameRequired: 'Įveskite vardą',
    contactNamePlaceholder: 'Jūsų vardas',
    contactMessagePlaceholder: 'Jūsų klausimas ar žinutė...',
    donateAmount050: '0,50 €',
    donateAmount1: '1 €',
    donateAmount2: '2 €',
    donateAmountCustom: 'Kita',
    donateCustomPlaceholder: 'Suma (€)',
    donateButton: 'Paremti',
    donateMessagePrefill: 'Norėčiau paremti {{amount}} €.',
    donateCustomInvalid: 'Įveskite teisingą sumą.',
    privacyPolicy: 'Privatumo politika',
    termsOfService: 'Paslaugų teikimo sąlygos',
    allRightsReserved: 'Visos teisės saugomos.',
    tmdbDisclaimer: 'Šis produktas naudoja TMDb API, bet nėra patvirtintas ar sertifikuotas TMDb.',
    
    // Comments
    comments: 'Komentarai',
    yourRating: 'Jūsų įvertinimas',
    commentPlaceholder: 'Parašykite savo nuomonę apie filmą...',
    postComment: 'Skelbti komentarą',
    updateComment: 'Atnaujinti komentarą',
    deleteComment: 'Ištrinti komentarą',
    noComments: 'Dar nėra komentarų. Būkite pirmas!',
    loginToComment: 'Prisijunkite, kad galėtumėte palikti komentarą ir įvertinimą.',
    ratingRequired: 'Pasirinkite įvertinimą',
    commentTooShort: 'Komentaras per trumpas (min. 3 simboliai)',
    commentError: 'Nepavyko paskelbti komentaro',

    rankBeginner: 'Naujokas',
    rankViewer: 'Žiūrovas',
    rankReviewer: 'Apžvalgininkas',
    rankConnoisseur: 'Kino žinovas',
    rankExpert: 'Kino ekspertas',
    rankCritic: 'Filmų kritikas',
    rankUpTitle: 'Naujas rangas!',
    rankUpDesc: 'Toliau rašykite komentarus ir rinkite taškus!',
    nextRank: 'Kitas rangas',
    pointsShort: 'tšk.',

    // Language
    language: 'Kalba',
    selectLanguage: 'Pasirinkite kalbą'
  },
  en: {
    // Header
    searchPlaceholder: 'Search movies...',
    login: 'Log in',
    register: 'Sign up',
    logout: 'Log out',
    movies: 'Movies',
    tvShows: 'TV Shows',
    cinema: 'Cinema',
    watchlist: 'Watchlist',
    watched: 'Watched',
    collections: 'Collections',
    favorites: 'Favorites',
    
    // Mobile navigation short labels
    moviesShort: 'Movies',
    tvShort: 'TV',
    cinemaShort: 'Cinema',
    watchlistShort: 'List',
    watchedShort: 'Seen',
    collectionsShort: 'Sets',
    favoritesShort: 'Favs',
    
    // Search
    showAllResults: 'Show all results',
    searchDropdownLoading: 'Searching...',
    searchSuggestionsEmpty: 'No results found',
    searchSuggestionsEmptyHint: 'Nothing matched your search. Try different words.',
    film: 'Film',
    
    // Auth
    confirmEmail: 'Confirm your email address',
    confirmEmailDesc: 'Check your email and click the confirmation link to access all features.',
    resendEmail: 'Resend',
    sending: 'Sending...',
    dismiss: 'Dismiss',
    
    // Auth benefits page
    createFreeAccount: 'Create a free account',
    loginOrRegisterPrompt: 'Log in or sign up to access all features',
    watchlistBenefit: 'Watchlist',
    watchlistBenefitDesc: 'Save movies and shows to watch later',
    watchedBenefit: 'Watched movies',
    watchedBenefitDesc: 'Track what you\'ve seen and rate it',
    favoritesBenefit: 'Favorites',
    favoritesBenefitDesc: 'Create your collection of favorite movies',
    registerFree: 'Sign up for free',
    alreadyHaveAccount: 'Already have an account',
    registrationFast: 'Registration takes less than a minute',
    
    // Media details
    description: 'Description',
    noDescription: 'No description available',
    shareReviewHint: 'Add your review to display it in the generated image. If you don\'t add a review, the movie description will be shown. Your rating will be included if you have marked the movie as watched.',
    goBack: 'Go back',
    season: 'season',
    seasons: 'seasons',
    episode: 'episode',
    episodes: 'episodes',
    streamingOn: 'Streaming on',
    studio: 'Studio',
    country: 'Country',
    mediaLanguage: 'Language',
    addToFavorites: 'Add to favorites',
    removeFromFavorites: 'Remove from favorites',
    watchLater: 'Watch later',
    removeFromWatchlist: 'Remove from watchlist',
    markAsWatched: 'Mark as watched',
    removeFromWatched: 'Remove from watched',
    share: 'Share',
    whereToWatch: 'Where to watch',
    subscription: 'Subscription',
    rent: 'Rent',
    buy: 'Buy',
    free: 'Free',
    trailers: 'Trailers',
    cast: 'Cast',
    similarMovies: 'Similar movies',
    similarShows: 'Similar TV shows',
    streamingInfo: 'Streaming info provided by',
    pricesVary: 'Prices and availability may vary',
    budget: 'Budget',
    revenue: 'Revenue',
    notAvailable: 'Not available',
    notAvailableDesc: 'This movie is currently not available to watch in your region through official platforms',
    movieNotFound: 'Movie not found',
    tvNotFound: 'TV show not found',
    movieNotFoundDesc: 'Sorry, this movie information is currently unavailable. It may have been removed from the database or a technical error occurred.',
    tvNotFoundDesc: 'Sorry, this TV show information is currently unavailable. It may have been removed from the database or a technical error occurred.',
    unknownError: 'An unknown error occurred',
    
    // Collections
    backToCollections: 'Back to collections',
    collectionEmpty: 'Collection is empty',
    collectionEmptyDesc: 'This collection has no items yet.',
    showing: 'Showing',
    of: 'of',
    curator: 'Curator',
    items: 'items',
    loadMore: 'Load more',
    loading: 'Loading...',
    errorLoading: 'Error loading data',
    retry: 'Try again',
    curatorCollections: 'Curated Collections',
    collectionsDesc: 'Discover hand-picked movie and TV show lists from the most trusted curators',
    collectionsCount: 'Collections',
    movieCollections: 'Movie Collections',
    tvCollections: 'TV Collections',
    searchCollections: 'Search collections...',
    
    // Footer
    footerDesc: 'Your ultimate movie and TV show discovery destination. Get personalized recommendations and never miss what\'s popular.',
    discover: 'Discover',
    popularMovies: 'Popular movies',
    topRated: 'Top rated',
    comingSoon: 'Coming soon',
    help: 'Help',
    helpCenter: 'Help center',
    contactUs: 'Contact us',
    contactNav: 'Contact',
    contactTitle: 'Contact',
    contactIntro: 'Questions or feedback? Send us a message — we will reply as soon as we can.',
    contactNameLabel: 'Name',
    contactEmailLabel: 'Email',
    contactMessageLabel: 'Message',
    contactSubmit: 'Send',
    contactSending: 'Sending...',
    contactSuccess: 'Message sent. Thank you!',
    contactError: 'Could not send. Please try again or use the email below.',
    contactNotConfigured: 'Form submission is not configured yet. Please use the email below.',
    contactFallback: 'You can also email us at:',
    contactEmailInvalid: 'Please enter a valid email address',
    contactNameRequired: 'Please enter your name',
    contactNamePlaceholder: 'Your name',
    contactMessagePlaceholder: 'Your question or message...',
    donateAmount050: '€0.50',
    donateAmount1: '€1',
    donateAmount2: '€2',
    donateAmountCustom: 'Custom',
    donateCustomPlaceholder: 'Amount (€)',
    donateButton: 'Support',
    donateMessagePrefill: 'I would like to support with {{amount}} €.',
    donateCustomInvalid: 'Enter a valid amount.',
    privacyPolicy: 'Privacy policy',
    termsOfService: 'Terms of service',
    allRightsReserved: 'All rights reserved.',
    tmdbDisclaimer: 'This product uses the TMDb API but is not endorsed or certified by TMDb.',
    
    // Comments
    comments: 'Comments',
    yourRating: 'Your rating',
    commentPlaceholder: 'Share your thoughts about this movie...',
    postComment: 'Post comment',
    updateComment: 'Update comment',
    deleteComment: 'Delete comment',
    noComments: 'No comments yet. Be the first!',
    loginToComment: 'Log in to leave a comment and rating.',
    ratingRequired: 'Please select a rating',
    commentTooShort: 'Comment is too short (min. 3 characters)',
    commentError: 'Failed to post comment',

    rankBeginner: 'Beginner',
    rankViewer: 'Viewer',
    rankReviewer: 'Reviewer',
    rankConnoisseur: 'Film Connoisseur',
    rankExpert: 'Film Expert',
    rankCritic: 'Film Critic',
    rankUpTitle: 'New Rank!',
    rankUpDesc: 'Keep posting reviews and collecting points!',
    nextRank: 'Next rank',
    pointsShort: 'pts',

    // Language
    language: 'Language',
    selectLanguage: 'Select language'
  },
  uk: {
    // Header
    searchPlaceholder: 'Шукати фільми...',
    login: 'Увійти',
    register: 'Реєстрація',
    logout: 'Вийти',
    movies: 'Фільми',
    tvShows: 'Серіали',
    cinema: 'Кінотеатр',
    watchlist: 'Список перегляду',
    watched: 'Переглянуто',
    collections: 'Колекції',
    favorites: 'Улюблені',
    
    // Mobile navigation short labels
    moviesShort: 'Фільми',
    tvShort: 'ТБ',
    cinemaShort: 'Кіно',
    watchlistShort: 'Список',
    watchedShort: 'Бачив',
    collectionsShort: 'Набори',
    favoritesShort: 'Улюблені',
    
    // Search
    showAllResults: 'Показати всі результати',
    searchDropdownLoading: 'Пошук...',
    searchSuggestionsEmpty: 'Нічого не знайдено',
    searchSuggestionsEmptyHint: 'За цим запитом нічого не знайдено. Спробуйте інші слова.',
    film: 'Фільм',
    
    // Auth
    confirmEmail: 'Підтвердіть свою електронну адресу',
    confirmEmailDesc: 'Перевірте електронну пошту та натисніть посилання для підтвердження, щоб отримати доступ до всіх функцій.',
    resendEmail: 'Надіслати ще раз',
    sending: 'Надсилання...',
    dismiss: 'Закрити',
    
    // Auth benefits page
    createFreeAccount: 'Створіть безкоштовний обліковий запис',
    loginOrRegisterPrompt: 'Увійдіть або зареєструйтесь, щоб отримати доступ до всіх функцій',
    watchlistBenefit: 'Список перегляду',
    watchlistBenefitDesc: 'Зберігайте фільми та серіали для перегляду пізніше',
    watchedBenefit: 'Переглянуті фільми',
    watchedBenefitDesc: 'Відстежуйте, що ви вже бачили, та оцінюйте',
    favoritesBenefit: 'Улюблені',
    favoritesBenefitDesc: 'Створюйте колекцію улюблених фільмів',
    registerFree: 'Зареєструватися безкоштовно',
    alreadyHaveAccount: 'Вже маю обліковий запис',
    registrationFast: 'Реєстрація займає менше хвилини',
    
    // Media details
    description: 'Опис',
    noDescription: 'Опис недоступний',
    shareReviewHint: 'Додайте свій відгук, щоб він відображався на створеному зображенні. Якщо ви не додасте відгук, буде показано опис фільму. Ваша оцінка буде включена, якщо ви позначили фільм як переглянутий.',
    goBack: 'Назад',
    season: 'сезон',
    seasons: 'сезони',
    episode: 'епізод',
    episodes: 'епізоди',
    streamingOn: 'Трансляція на',
    studio: 'Студія',
    country: 'Країна',
    mediaLanguage: 'Мова',
    addToFavorites: 'Додати до улюблених',
    removeFromFavorites: 'Видалити з улюблених',
    watchLater: 'Дивитися пізніше',
    removeFromWatchlist: 'Видалити зі списку',
    markAsWatched: 'Позначити як переглянуте',
    removeFromWatched: 'Видалити з переглянутих',
    share: 'Поділитися',
    whereToWatch: 'Де дивитися',
    subscription: 'Підписка',
    rent: 'Оренда',
    buy: 'Купити',
    free: 'Безкоштовно',
    trailers: 'Трейлери',
    cast: 'Актори',
    similarMovies: 'Схожі фільми',
    similarShows: 'Схожі серіали',
    streamingInfo: 'Інформація про стрімінг надана',
    pricesVary: 'Ціни та доступність можуть відрізнятися',
    budget: 'Бюджет',
    revenue: 'Касові збори',
    notAvailable: 'Недоступно',
    notAvailableDesc: 'Цей фільм наразі недоступний для перегляду у вашому регіоні через офіційні платформи',
    movieNotFound: 'Фільм не знайдено',
    tvNotFound: 'Серіал не знайдено',
    movieNotFoundDesc: 'Вибачте, інформація про цей фільм наразі недоступна. Можливо, він був видалений з бази даних або сталася технічна помилка.',
    tvNotFoundDesc: 'Вибачте, інформація про цей серіал наразі недоступна. Можливо, він був видалений з бази даних або сталася технічна помилка.',
    unknownError: 'Сталася невідома помилка',
    
    // Collections
    backToCollections: 'Назад до колекцій',
    collectionEmpty: 'Колекція порожня',
    collectionEmptyDesc: 'У цій колекції поки немає елементів.',
    showing: 'Показано',
    of: 'з',
    curator: 'Куратор',
    items: 'елементів',
    loadMore: 'Завантажити ще',
    loading: 'Завантаження...',
    errorLoading: 'Помилка завантаження даних',
    retry: 'Спробувати ще раз',
    curatorCollections: 'Кураторські колекції',
    collectionsDesc: 'Відкрийте для себе добірки фільмів та серіалів від найкращих кураторів',
    collectionsCount: 'Колекцій',
    movieCollections: 'Колекцій фільмів',
    tvCollections: 'Колекцій серіалів',
    searchCollections: 'Шукати колекції...',
    
    // Footer
    footerDesc: 'Ваше найкраще місце для відкриття фільмів та серіалів. Отримуйте персоналізовані рекомендації та не пропускайте популярне.',
    discover: 'Відкрийте',
    popularMovies: 'Популярні фільми',
    topRated: 'Найкращі',
    comingSoon: 'Скоро',
    help: 'Допомога',
    helpCenter: 'Центр допомоги',
    contactUs: 'Зв\'яжіться з нами',
    contactNav: 'Контакти',
    contactTitle: 'Контакти',
    contactIntro: 'Є питання чи пропозиції? Напишіть нам — відповімо якнайшвидше.',
    contactNameLabel: 'Ім\'я',
    contactEmailLabel: 'Електронна пошта',
    contactMessageLabel: 'Повідомлення',
    contactSubmit: 'Надіслати',
    contactSending: 'Надсилання...',
    contactSuccess: 'Повідомлення надіслано. Дякуємо!',
    contactError: 'Не вдалося надіслати. Спробуйте ще раз або напишіть на пошту нижче.',
    contactNotConfigured: 'Відправка форми ще не налаштована. Використайте пошту нижче.',
    contactFallback: 'Також можете написати напряму:',
    contactEmailInvalid: 'Введіть коректну адресу електронної пошти',
    contactNameRequired: 'Введіть ім\'я',
    contactNamePlaceholder: 'Ваше ім\'я',
    contactMessagePlaceholder: 'Ваше запитання або повідомлення...',
    donateAmount050: '0,50 €',
    donateAmount1: '1 €',
    donateAmount2: '2 €',
    donateAmountCustom: 'Інша',
    donateCustomPlaceholder: 'Сума (€)',
    donateButton: 'Підтримати',
    donateMessagePrefill: 'Хочу підтримати на {{amount}} €.',
    donateCustomInvalid: 'Введіть коректну суму.',
    privacyPolicy: 'Політика конфіденційності',
    termsOfService: 'Умови використання',
    allRightsReserved: 'Всі права захищені.',
    tmdbDisclaimer: 'Цей продукт використовує TMDb API, але не схвалений та не сертифікований TMDb.',
    
    // Comments
    comments: 'Коментарі',
    yourRating: 'Ваша оцінка',
    commentPlaceholder: 'Поділіться враженнями про фільм...',
    postComment: 'Опублікувати коментар',
    updateComment: 'Оновити коментар',
    deleteComment: 'Видалити коментар',
    noComments: 'Ще немає коментарів. Будьте першим!',
    loginToComment: 'Увійдіть, щоб залишити коментар та оцінку.',
    ratingRequired: 'Оберіть оцінку',
    commentTooShort: 'Коментар занадто короткий (мін. 3 символи)',
    commentError: 'Не вдалося опублікувати коментар',

    rankBeginner: 'Початківець',
    rankViewer: 'Глядач',
    rankReviewer: 'Оглядач',
    rankConnoisseur: 'Кінознавець',
    rankExpert: 'Кіноексперт',
    rankCritic: 'Кінокритик',
    rankUpTitle: 'Новий ранг!',
    rankUpDesc: 'Продовжуйте писати відгуки та збирати бали!',
    nextRank: 'Наступний ранг',
    pointsShort: 'бал.',

    // Language
    language: 'Мова',
    selectLanguage: 'Виберіть мову'
  }
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved && LANGUAGES[saved] ? saved : 'lt';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const setLanguage = (code) => {
    if (LANGUAGES[code]) {
      setLanguageState(code);
    }
  };

  const t = (key) => {
    return TRANSLATIONS[language]?.[key] || TRANSLATIONS.lt[key] || key;
  };

  const currentLanguage = LANGUAGES[language];
  const tmdbLanguage = currentLanguage?.tmdbCode || 'lt';

  return (
    <LanguageContext.Provider value={{ 
      language, 
      setLanguage, 
      t, 
      currentLanguage,
      tmdbLanguage,
      languages: LANGUAGES 
    }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}

export { LANGUAGES, TRANSLATIONS };

